import { render, staticRenderFns } from "./DailyOther.vue?vue&type=template&id=2040a65f&scoped=true&"
import script from "./DailyOther.vue?vue&type=script&lang=js&"
export * from "./DailyOther.vue?vue&type=script&lang=js&"
import style0 from "./DailyOther.vue?vue&type=style&index=0&id=2040a65f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2040a65f",
  null
  
)

export default component.exports